import Reveal from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "As Raízes",
    text: "Todo bonsai começa com uma semente e mãos pacientes. O Projeto Bonsai nasceu no bairro Além Ponte, em Sorocaba, com um propósito simples: levar o Jiu-Jitsu — e tudo o que ele ensina — para quem mais precisa, sem custo algum e de portas abertas a todo o público.",
    wide: true,
  },
  {
    num: "02",
    title: "O Cultivo da Mente",
    text: "No tatame, cada queda é uma lição. Trabalhamos disciplina, respeito e autocontrole — podando com cuidado os limites de cada aluno para que cresçam fortes, dentro e fora do dojo.",
    wide: false,
  },
  {
    num: "03",
    title: "O Impacto Social",
    text: "Aberto ao público, o projeto vai além: ampara casas de abrigo, dando a crianças desamparadas um lugar de acolhimento, disciplina e família. O Bonsai floresce quando cada aluno se torna exemplo para o próximo.",
    wide: false,
  },
];

const IMAGES = [
  {
    src: "/assets/treino-tatame.jpeg",
    alt: "Treino real da turma do Projeto Bonsai no tatame",
    caption: "BRAZILIAN JIU-JITSU",
  },
  {
    src: "/assets/corpo-espirito.jpeg",
    alt: "Alunos do Projeto Bonsai em reverência sincronizada no tatame",
    caption: "CORPO / ESPÍRITO",
  },
];

export default function History() {
  return (
    <section id="historia" className="relative py-28 sm:py-36" data-testid="history-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.3em] text-gold mb-4" data-testid="history-eyebrow">NOSSA HISTÓRIA</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl" data-testid="history-title">
            Como um bonsai, grandes vidas são cultivadas com paciência.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.12} className={c.wide ? "md:col-span-2" : ""}>
              <article
                data-testid={`history-chapter-${c.num}`}
                className="group h-full bg-surface border border-white/10 hover:border-gold/40 rounded-2xl p-8 sm:p-10 transition-all duration-500 hover:bg-[#1A1A20] hover:shadow-[0_0_40px_rgba(212,175,55,0.08)]"
              >
                <span className="font-mono text-5xl sm:text-6xl font-bold text-outline-gold group-hover:[-webkit-text-stroke-color:#D4AF37] transition-all duration-500">{c.num}</span>
                <h3 className="font-display text-xl sm:text-2xl font-semibold mt-6 text-gold">{c.title}</h3>
                <p className="mt-4 text-zinc-400 leading-relaxed text-base">{c.text}</p>
              </article>
            </Reveal>
          ))}

          {IMAGES.map((img, i) => (
            <Reveal key={img.src} delay={0.12 + i * 0.12}>
              <figure className="group relative h-72 md:h-full min-h-72 rounded-2xl overflow-hidden border border-white/10" data-testid={`history-image-${i}`}>
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-transparent to-transparent" />
                <figcaption className="absolute bottom-4 left-4 font-mono text-xs tracking-[0.25em] text-gold">{img.caption}</figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
